import { LOCAL_STORAGE_KEYS } from 'config/Vars'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import useLocalStorage from 'modules/core/lib/useLocalStorage'
import legalEntities from 'modules/core/store/collections/legalEntities'

import { ChargebeeSubscriptionFormFirstStep } from '../components/PaymentGateway/FullScreenStep/form'

const useAutoCompleteBillingInfo = () => {
  const { email } = useCurrentSession()

  const mainLegalEntity = legalEntities.main
  const firstStepFields = {
    country: mainLegalEntity?.attributes?.country,
    mx_tax_system: null,
    vat_number: '',
    company: mainLegalEntity?.attributes?.legal_name,
    address_line: mainLegalEntity?.attributes?.address_line_1,
    city: mainLegalEntity?.attributes?.city,
    zip: mainLegalEntity?.attributes?.postal_code,
    state: mainLegalEntity?.attributes?.state,
    email,
  }

  const [data, setData] = useLocalStorage<ChargebeeSubscriptionFormFirstStep>(
    LOCAL_STORAGE_KEYS.autocompleteBillingInfo,
    firstStepFields
  )

  const writeData = (newData: ChargebeeSubscriptionFormFirstStep) => {
    setData({ ...data, ...newData })
  }

  const isAutoCompleted = !!data && JSON.stringify(data) !== JSON.stringify(firstStepFields)

  return { data, writeData, isAutoCompleted }
}

export default useAutoCompleteBillingInfo
